import { useContext } from 'react';
import { CreateTransactionsContext, CreateTransactionsValues } from '../contexts/CreateTransactionsContext';
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, Autocomplete, Switch, FormControlLabel } from '@mui/material';

export const CreateTransactionsTopForms = () => {
  const { transactionTypesToShow,
    handleTypeChange,
    handleSearchTermChange,
    handleItemSelect,
    dropDownItems,
    transactionType,
    createDate,
    handleCreateDateChange,
    value,
    searchTerm,
    itemsToCreate,
    isItemsLoading,
    isDisableActions,
    handleRecentActivity,
    hasRecentActivity,
    t } = useContext(CreateTransactionsContext) as CreateTransactionsValues;

  return (
    <>
      <Grid item
        xs={6}>
        <FormControl fullWidth
          size='small'>
          <InputLabel id="transaction-types-label">{t('transactionTypes')}</InputLabel>
          <Select
            labelId="transaction-types-label"
            id="transaction-types-select"
            disabled={isDisableActions}
            value={transactionType?.id ?? ''}
            label={t('transactionTypes')}
            onChange={handleTypeChange}
          >
            <MenuItem value="">
              <em>{t('none')}</em>
            </MenuItem>
            {transactionTypesToShow().map((type) => {
              return <MenuItem key={type.id}
                value={type.id}>{type.type}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Grid><Grid item
        xs={6}>
        <FormControl fullWidth
          size='small'>
          <TextField
            id="datetime-input"
            label={t('Date')}
            type='datetime-local' 
            size='small'
            variant="outlined"
            disabled={isDisableActions}
            value={new Date(createDate.getTime() - createDate.getTimezoneOffset() * 60000).toISOString().slice(0, 16)} // Adjust for timezone offset
            onChange={handleCreateDateChange}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              
              max: new Date().toISOString().slice(0, 16),
            }}
          />
        </FormControl>
      </Grid>
      <Grid item
        xs={12}>
        <Autocomplete
          size='small'
          loading={isItemsLoading}
          value={value}
          disabled={transactionType == undefined || isDisableActions}
          onChange={(event, newValue: string | null | undefined) => {
            if (newValue) {
              handleItemSelect(newValue);
            }
          }}
          inputValue={searchTerm}
          onInputChange={(event, newInputValue) => {
            handleSearchTermChange(newInputValue);
          }}
          isOptionEqualToValue={(x, y) => true}

          options={dropDownItems}
          filterOptions={(x) => x}

          getOptionDisabled={(option) => itemsToCreate.some(x => x.itemNumber + ' - ' + x.description == option)}
          id="controllable-states-demo"
          renderInput={(params) => <TextField {...params}
            label={t('itemNumberOrDescription')} />} />
      </Grid>
      <Grid xs= {12}>
        <FormControlLabel
          control={<Switch
            checked={hasRecentActivity}
            onChange={handleRecentActivity}
          />}
          label={t('hasRecentActivity')}
          labelPlacement="start"
        />
      </Grid>
    </>
  );
};

